var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-overlay',{attrs:{"show":_vm.isShow}},[_c('div',{staticClass:"logding-wrapper"},[_c('van-loading',{attrs:{"size":"24px","vertical":"","color":"#ff5f16"}},[_vm._v(_vm._s(_vm.lodingTxt))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }